import React, { Component } from 'react';

import PlayPauseButton from '../ui/PlayPauseButton';
import VolumeControls from '../ui/VolumeControls';

import style from './AudioPlayer.module.scss';

class AudioPlayer extends Component {
  state = {
    isAudioPaused: true,
    isVolumeOpen: false,
    currVolume: '',
    durationInt: '',
    currTimeInt: '',
    duration: '',
    currTime: '',
  };

  // Check for trailing zero and add to time if needed
  strPadLeft = (string, pad, length) => {
    return (new Array(length + 1).join(pad) + string).slice(-length);
  };

  // Convert seconds into minutes:seconds
  convertTime = time => {
    const roundedTime = Math.ceil(time);
    const minutes = Math.floor(roundedTime / 60);
    const seconds = roundedTime - minutes * 60;

    return `${minutes}:${this.strPadLeft(seconds, '0', 2)}`;
  };

  setAudioState = () => {
    const audio = this.audio;

    if (audio !== null) {
      this.setState({
        durationInt: audio.duration,
        currTimeInt: audio.currentTime,
        duration: this.convertTime(audio.duration),
        currTime: this.convertTime(audio.currentTime),
      });
    }
  };

  handleProgress = () => {
    this.setAudioState();

    this.animateProgress = requestAnimationFrame(this.handleProgress);
  };

  getProgressWidth = (currentTime, duration) => {
    return (currentTime / duration) * 100 + '%';
  };

  setAudioProgress = () => {
    return {
      width: this.getProgressWidth(
        this.state.currTimeInt,
        this.state.durationInt
      ),
    };
  };

  getTouchAmount = e => {
    const rect = this.progressWrapper.getBoundingClientRect();

    if (e.type === 'mousemove' || e.type === 'mousedown') {
      return (e.clientX - rect.left) / rect.width;
    } else if (e.type === 'touchmove' || e.type === 'touchstart') {
      return (e.touches[0].clientX - rect.left) / rect.width;
    }
  };

  handleScrubMove = e => {
    const percentage = this.getTouchAmount(e);

    this.audio.currentTime = percentage * this.state.durationInt;

    if (this.state.isAudioPaused) {
      this.setAudioState();
    }
  };

  handleScrubUp = e => {
    if (e.type === 'mouseup') {
      window.removeEventListener('mousemove', this.handleScrubMove);
      window.removeEventListener('mouseup', this.handleScrubUp);
    } else if (e.type === 'touchend') {
      window.removeEventListener('touchmove', this.handleScrubMove);
      window.removeEventListener('touchend', this.handleScrubUp);
    }
  };

  handleMouseDown = e => {
    e.preventDefault();
    window.addEventListener('mousemove', this.handleScrubMove);
    window.addEventListener('mouseup', this.handleScrubUp);
    this.handleScrubMove(e);
  };

  handleTouchStart = e => {
    e.preventDefault();
    window.addEventListener('touchmove', this.handleScrubMove);
    window.addEventListener('touchend', this.handleScrubUp);
    this.handleScrubMove(e);
  };

  handlePlayPause = () => {
    this.setState(state => ({
      isAudioPaused: !state.isAudioPaused,
    }));
  };

  handleVolumeVisibility = () => {
    this.setState(state => ({
      isVolumeOpen: !state.isVolumeOpen,
    }));
  };

  handleVolumeLevel = e => {
    this.setState({
      currVolume: e.target.value,
    });

    this.audio.volume = this.state.currVolume;
  };

  componentDidMount() {
    const audio = this.audio;

    if (audio !== null) {
      audio.addEventListener('loadedmetadata', () => {
        this.setAudioState();
      });

      audio.addEventListener('pause', () => {
        this.setState({
          isAudioPaused: true,
        });
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // Check if audio is paused
    if (prevState.isAudioPaused !== this.state.isAudioPaused) {
      console.log(this.audio);
      if (this.state.isAudioPaused) {
        this.audio.pause();
        cancelAnimationFrame(this.animateProgress);
      } else {
        this.audio.play();
        this.animateProgress = requestAnimationFrame(this.handleProgress);
      }
    }
  }

  render() {
    return (
      <div className={style.audioWrapper}>
        <audio
          src={this.props.source}
          preload="auto"
          className={style.audioElement}
          ref={el => (this.audio = el)}
        >
          <p>
            Your browser does not support native audio, but you can{' '}
            <a href={this.props.source} target="_blank">
              download this MP3
            </a>{' '}
            to listen on your device.
          </p>
        </audio>

        <div className={style.audioPlayer}>
          <PlayPauseButton
            onPlayPauseClick={this.handlePlayPause}
            isAudioPaused={this.state.isAudioPaused}
            noBorder
          />

          <div className={style.audioInfo}>
            <div className={style.audioTitle}>{this.props.title}</div>
            <div className={style.audioControls}>
              <div
                className={style.progressWrapper}
                onMouseDown={this.handleMouseDown}
                onTouchStart={this.handleTouchStart}
                ref={el => (this.progressWrapper = el)}
              >
                <div
                  className={`audio-progress ${style.progress}`}
                  style={this.setAudioProgress()}
                />
              </div>
              <div className={style.audioTime}>
                <span className={style.currTime}>{this.state.currTime}</span>
                <span className={style.duration}>{this.state.duration}</span>
              </div>
              <VolumeControls
                currVolume={this.state.currVolume}
                handleVolumeVisibility={this.handleVolumeVisibility}
                handleVolumeLevel={this.handleVolumeLevel}
                isVolumeOpen={this.state.isVolumeOpen}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AudioPlayer;



// WEBPACK FOOTER //
// ./src/components/global/AudioPlayer.js